import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Amazon from "../helpers/Amazon";
import { useState } from "react";
import Loading from "./Loading";


export default function AddAmazon({ productId, onCallback }) {
    const { register, handleSubmit } = useForm();
    const [loading, setLoading] = useState(false);

    const onSubmit = handleSubmit((values) => {
        console.log('test')
        setLoading(true);

        Amazon.create({
            product_id: productId,
            asin: values.asin,
            link: values.link,
            price: values.price,
            salePrice: values.salePrice,
        }).then((data) => {
            onCallback(data);
        }).catch(() => {
            setLoading(false)
        })
    });

    return (
        <div className="outline-1 outline-gray-300 p-2 rounded flex flex-col gap-y-2">
            <div className="flex justify-between items-center">
                <h3 className="text-md font-medium leading-6 text-gray-900">Add amazon</h3>
            </div>
            {loading ? <Loading /> : (
                <form id="amazon-create" className="flex flex-col gap-y-2" onSubmit={onSubmit}>
                    <div className="flex flex-col">
                        <label>ASIN</label>
                        <input
                            {...register('asin')}
                            placeholder="ASIN"
                            type="text"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                    </div>
                    <div className="flex flex-col">
                        <label>Link (It should be amazon affiliate link)</label>
                        <input
                            {...register('link')}
                            placeholder="Link (It should be amazon affiliate link)"
                            type="url"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                    </div>
                    <div className="flex flex-col">
                        <label>Price</label>
                        <input
                            {...register('price')}
                            placeholder="Price"
                            type="text"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                    </div>
                    <div className="flex flex-col">
                        <label>Sale Price</label>
                        <input
                            {...register('salePrice')}
                            placeholder="Sale Price"
                            type="text"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                    </div>

                    <div className="flex items-center justify-end gap-x-6">
                        <button
                            onClick={onSubmit}
                            className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                        >
                            Save
                        </button>
                    </div>
                </form>
            )}

        </div>
    );
}
